export default __webpack_public_path__ + "static/media/Logo.a8d7ef9f.svg";